export const styles = {
  scrollerBase: {
    display: "flex",
    flex: "1 0 80%",
  },
  iconButtonBase: {
    padding: 0,
    borderRadius: 0,
    color: "var(--EventsBlueSecondary)",
  },
  itemsContainer: {
    overflow: "hidden",
    flexGrow: 1,
  },
  itemsInnerContainer: {
    display: "-webkit-inline-box",
    transition: "transform 300ms ease-in-out",
  },
  itemBase: {
    padding: "0 16px",
    color: "var(--LightGrey)",
    textAlign: "center",
    lineHeight: "2.75rem",
    fontSize: "14px",
    fontWeight: 700,
    marginRight: "8px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "events.blueSecondary",
      color: "white",
      borderRadius: "4px",
    },
  },
  itemActiveState: {
    backgroundColor: "events.blueSecondary",
    color: "white",
    borderRadius: "4px",
  },
};
